import {
  PreferredReturnAccrualMethod,
  PreferredReturnAccrualPeriod,
  PreferredReturnBasis,
  PreferredReturnCalculationEnd,
  PreferredReturnCompoundingPeriod,
} from 'further-types/lp/carry-settings';

const defaultCarriedInterestRate = {
  rate: 0,
  dpiThreshold: undefined,
};

const defaultTemplate = {
  name: '',
  carriedInterestRates: [defaultCarriedInterestRate],
  carriedInterestPartnerCatchupBetweenRateThresholds: false,
  preferredReturnRate: 0,
  preferredReturnAccrualMethod: PreferredReturnAccrualMethod.Simple,
  preferredReturnAccrualPeriod: PreferredReturnAccrualPeriod.Monthly,
  preferredReturnCalculationEnd:
    PreferredReturnCalculationEnd.UponFullReturnOfCapital,
  preferredReturnBasis: PreferredReturnBasis.Drawn,
  partnerCatchupSpeed: 0,
  isDefault: false,
  isInUse: false,
};

const preferredReturnAccrualMethodOptions = [
  {
    label: 'Simple',
    value: PreferredReturnAccrualMethod.Simple,
  },
  {
    label: 'Compound',
    value: PreferredReturnAccrualMethod.Compound,
  },
];

const preferredReturnAccrualPeriodOptions = Object.values(
  PreferredReturnAccrualPeriod,
).map((option) => ({
  label: option.toString(),
  value: option,
}));

const preferredReturnCompoundingPeriodOptions = Object.values(
  PreferredReturnCompoundingPeriod,
).map((option) => ({
  label: option.toString(),
  value: option,
}));

const preferredReturnCalculationEndOptions = [
  {
    label: 'Upon full return of capital',
    value: PreferredReturnCalculationEnd.UponFullReturnOfCapital,
  },
  {
    label: 'Upon full return of capital plus accrued preferred return',
    value:
      PreferredReturnCalculationEnd.UponFullReturnOfCapitalPlusAccruedPreferredReturn,
  },
];

const preferredReturnBasisOptions = [
  {
    label: 'Drawn',
    value: PreferredReturnBasis.Drawn,
  },
];

export default function useCarriedInterestFeeTemplatesOptions({
  useSimpleAccrualMethod,
}: {
  useSimpleAccrualMethod?: boolean;
} = {}) {
  return {
    defaultTemplate,
    defaultCarriedInterestRate,
    preferredReturnAccrualMethodOptions,
    preferredReturnAccrualPeriodOptions,
    preferredReturnCompoundingPeriodOptions,
    preferredReturnCalculationEndOptions:
      preferredReturnCalculationEndOptions.filter(
        (option) =>
          !useSimpleAccrualMethod ||
          option.value !==
            PreferredReturnCalculationEnd.UponFullReturnOfCapitalPlusAccruedPreferredReturn,
      ),
    preferredReturnBasisOptions,
  };
}
